import {AxiosRequestConfig} from 'axios';
import request from '../axios';
import {ILabEditDetail, ILabPosts, LabPostDetail} from '../../models/post/lab';
import {RemoveEmptyFiledFromObject} from '../../utilities/helper/removeEmptyFiledFromObject';
import {QueryFunctionContext} from 'react-query';

export const getLabPost = async (ctx: IGetPostsPayload, pageNumber: number) => {
  RemoveEmptyFiledFromObject(ctx);
  const {data}: {data: ILabPosts} = await request.get(
    `/api/v2/store/lab-post-list?page=` + pageNumber,
    {
      params: {
        ...ctx,
      },
    } as AxiosRequestConfig,
  );
  return data;
};
export const getLabDetail = async (ctx: QueryFunctionContext) => {
  const {data}: {data: LabPostDetail} = await request.get(
    `/api/v2/store/lab-post?guid=` + ctx.queryKey[1],
  );
  return data;
};
export const getLabEditDetail = async (guid: string) => {
  const {data}: {data: ILabEditDetail} = await request.get(
    `/api/v2/store/lab-edit-detail?guid=` + guid,
  );
  return data;
};
